const defaultState = {
  routing: {},
  user: {
    authCheckComplete: false,
    isRegistrationIdCheckComplete: false,
    isAuthenticated: false,
    registrationId: '',
  },
  // layout: { // todo
  //   quote: {
  //     author: null,
  //     svg: null,
  //     quote: null,
  //   }
  // },
  errors: {
    hasFatalError: false,
  },
  notifications: { list: [] },
};

export default defaultState;



// WEBPACK FOOTER //
// ./src/_app/store/defaultState.js